import React, { useState, useMemo } from "react";
import Modal from "components/organism/modal-v2";
import Button from "components/v1/Button";
import HTMLContentIframe from "components/HTMLContentIframe";

import { useGetListAnnouncement } from "api/announcement/query";

const decodeHtml = (html) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};

const convertUrlsToLinks = (html) => {
  if (!html) return "";

  // Decode HTML entities first
  const decoded = decodeHtml(html);

  // Regular expression to match URLs
  const urlRegex = /(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/g;

  // Replace URLs with anchor tags
  const withLinks = decoded.replace(urlRegex, (url) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color: #1B67DA; text-decoration: underline;">${url}</a>`;
  });

  return withLinks;
};

const Beranda = () => {
  const { data: announcements } = useGetListAnnouncement();

  const SLIDES = useMemo(() => {
    if (!announcements?.data?.data?.length) return [];
    return announcements.data.data.map((announcement) => ({
      id: announcement?.id,
      image: announcement?.image?.url || "",
      title: announcement?.title || "",
      content: convertUrlsToLinks(announcement?.content || ""),
    }));
  }, [announcements]);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSlide, setSelectedSlide] = useState(null);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : SLIDES.length - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev < SLIDES.length - 1 ? prev + 1 : 0));
  };

  const handleImageClick = (slide) => {
    setSelectedSlide(slide);
    setIsModalOpen(true);
  };

  const getVisibleSlides = () => {
    const prevIndex = currentIndex === 0 ? SLIDES.length - 1 : currentIndex - 1;
    const nextIndex = currentIndex === SLIDES.length - 1 ? 0 : currentIndex + 1;

    return [
      { ...SLIDES[prevIndex], position: "left", originalIndex: prevIndex },
      {
        ...SLIDES[currentIndex],
        position: "center",
        originalIndex: currentIndex,
      },
      { ...SLIDES[nextIndex], position: "right", originalIndex: nextIndex },
    ];
  };

  return (
    <>
      <div className="wrapper nav-content-wrapper bg-white h-screen">
        <div>
          <h1 className="px-6 text-[34px] font-inter-semibold leading-[40px] text-[#252526] mt-4">
            Selamat datang kembali!
          </h1>

          <div className="flex items-center h-[calc(100vh-56px)]">
            <div className="relative  overflow-hidden">
              <div className="flex gap-6 justify-center items-center">
                {getVisibleSlides().map((slide, index) => (
                  <div
                    key={`${slide.id}-${slide.position}`}
                    className="flex-shrink-0 transition-all duration-300"
                    style={{
                      width: "905px",
                      height: "510px",
                    }}
                  >
                    <img
                      src={slide.image}
                      alt={slide.title}
                      className="w-full h-full object-cover rounded-[16px] border-[0.5px] border-solid border-[#DEDFDE]"
                      onClick={() =>
                        slide.position === "center" && handleImageClick(slide)
                      }
                      style={{
                        cursor:
                          slide.position === "center" ? "pointer" : "default",
                      }}
                    />
                  </div>
                ))}
              </div>

              <button
                onClick={handlePrev}
                className="absolute left-1/2 -translate-x-[370px] top-1/2 -translate-y-1/2 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center shadow-lg hover:bg-white transition-all z-10"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M15 18L9 12L15 6"
                    stroke="#252526"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>

              <button
                onClick={handleNext}
                className="absolute left-1/2 translate-x-[330px] top-1/2 -translate-y-1/2 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center shadow-lg hover:bg-white transition-all z-10"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M9 18L15 12L9 6"
                    stroke="#252526"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>

              <div className="flex justify-center gap-2 mt-4">
                {SLIDES.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentIndex(index)}
                    className={`w-2 h-2 rounded-full transition-all ${
                      index === currentIndex
                        ? "bg-[#1B67DA] w-6"
                        : "bg-[#D8D8D9]"
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className="w-[555px] z-[42] bg-white rounded-md border-[0.5px] border-solid border-[#ECECEC] shadow-[0px_1px_3px_0px_rgba(16,16,16,0.10),_0px_1px_2px_0px_rgba(16,16,16,0.06)]">
          <div className="p-2 max-h-[674px]">
            <p className="text-[17px] font-inter-semibold leading-[28px] mb-[12px]">
              {selectedSlide?.title}
            </p>
            <div className="w-full rounded-[4px] w-full aspect-[16/9] mb-[12px]">
              <img
                src={selectedSlide?.image}
                alt={selectedSlide?.title}
                className="w-full h-full object-cover rounded-[4px]"
              />
            </div>

            <div className="max-h-[700px] min-h-[700px]">
              <HTMLContentIframe content={selectedSlide?.content || ""} />
            </div>
          </div>

          <div className="flex items-center justify-end gap-4 px-4 py-2 border-t border-solid border-[#D8D8D9]">
            <Button onClick={() => setIsModalOpen(false)} text="Tutup" />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Beranda;
